export default __webpack_public_path__ + "static/media/img_password.91675025.png";